import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class StdIdentifierGroupService {
  static async detail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdIdentifierGroup/${payload.id}`)
    )
    return Callback(err, res)
  }
  static async list(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdIdentifierGroup?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async create(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdIdentifierGroup', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdIdentifierGroup', payload))
    return Callback(err, res)
  }
  static async remove(payload) {
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdIdentifierGroup', payload))
    return Callback(err, res)
  }
  static async upload(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdIdentifierGroup/import', payload)
    )
    return Callback(err, res)
  }
  static async exportFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdIdentifierGroup/export', payload)
    )
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdIdentifierGroup/download', payload)
    )
    return Callback(err, res)
  }
}
